import { observer } from 'mobx-react-lite'

import { ChooseNumberTabsContent } from 'entities/Phone/ui/ChooseNumberTabs/ChooseNumberTabsContent'
import { useTollFreeStepsContext } from 'pages/settings/pages/compliance/pages/tollFree/context/tollFreeStepsContext'

import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import styles from './styles.module.scss'

export const ChooseNumber = observer(() => {
  const {
    addTollFreeNumberStore: { chooseNumberTabsStore, addNumberNextClick },
  } = useTollFreeStepsContext()

  return (
    <div className={styles.wrap}>
      <ChooseNumberTabsContent store={chooseNumberTabsStore} />

      <NextButton
        disabled={!chooseNumberTabsStore.selectedNumber}
        text='Next'
        onClick={() => addNumberNextClick()}
      />
    </div>
  )
})
